import React from 'react';
import './App.css';
import DominicPortfolio from './Home';

function App() {
  return (
    <div className="App">
      <DominicPortfolio/>
    </div>
  );
}

export default App;
